export default "__VITE_ASSET__27513a98__"